import { zodTransformFirestoreTimestampToDate } from "../../utils/zodUtils.mjs";
import { zodFlavorId } from "../ids.mjs";
import { defineFirestoreCollection } from "../firebaseCollectionSchema.mjs";
import { executionTraceStampSchema } from "../executionTrace.mjs";
import { VendorSyncOps } from "../vendorSync/vendorSync.mjs";
import { z as z$1 } from "zod";

// src/models/billing/stripeCheckout.ts
const firestoreDate = z$1.any().transform(zodTransformFirestoreTimestampToDate);
/**
* Consult self-pay checkout attempt L4 — doc id = attempt id.
* Path: `stripe_checkouts/{stripeCheckoutId}`.
*
* Epoch-1: tracks Invoice charge (not hosted Checkout Session). Paid SSOT is
* the linked `stripe_invoices` doc; this mirrors attempt status.
*/
const stripeCheckoutStatusSchema = z$1.enum([
	"pending",
	"processing",
	"paid",
	"failed",
	"cancelled",
	"fail_retry",
	"cancel_failed"
]);
const stripeCheckoutSchema = z$1.object({
	id: zodFlavorId(),
	vendorNativeId: zodFlavorId(),
	consultationId: zodFlavorId(),
	linkedCustomerId: zodFlavorId().nullable().optional(),
	stripeCustomerId: zodFlavorId().optional(),
	stripeInvoiceId: zodFlavorId().nullable().optional(),
	stripeProductId: zodFlavorId().optional(),
	stripePriceId: zodFlavorId().optional(),
	consultType: z$1.string().optional(),
	status: stripeCheckoutStatusSchema.optional(),
	amount: z$1.number().optional(),
	currency: z$1.string().optional(),
	lastError: z$1.string().nullable().optional(),
	/** Visit card for off-session noshow/settlement; only on booking checkout docs. */
	paymentMethodId: z$1.string().optional(),
	metadata: z$1.record(z$1.string(), z$1.unknown()).optional(),
	snapshot: z$1.record(z$1.string(), z$1.unknown()).optional(),
	snapshotHash: z$1.string().optional(),
	observedAt: firestoreDate.optional(),
	lastSuccessfulEventId: z$1.string().optional(),
	createdAt: firestoreDate,
	updatedAt: firestoreDate,
	executionTrace: executionTraceStampSchema.optional()
});
const StripeCheckouts = defineFirestoreCollection("stripe_checkouts", stripeCheckoutSchema, { ops: VendorSyncOps }, {
	dwReplication: true,
	firestoreCollectionPath: "stripe_checkouts",
	executionTrace: true
});

export { StripeCheckouts, stripeCheckoutSchema, stripeCheckoutStatusSchema };
//# sourceMappingURL=stripeCheckout.mjs.map